var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{staticClass:"input",attrs:{"placeholder":"Buscar...","size":"mini"},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},[_c('el-button',{staticClass:"btn-append",attrs:{"slot":"append","size":"mini","disabled":this.loadSearch},on:{"click":_vm.search},slot:"append"},[_c('i',{class:_vm.icon})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }